import { Link } from 'components/common';
import { UpdatesItem, UpdatesListItem } from '.';

const UpdatesContentEn = () => (
  <div className="content">
    <UpdatesItem date="2026-10-26">
      <UpdatesListItem title="Improve course with AI">
        <p>
          If AI functionality has been enabled, you can now evaluate your course
          using AI and get suggestions on how to improve the course.
        </p>
        <p>
          You can find the functionality from the course editor view from the
          top right corner.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-10-08">
      <UpdatesListItem title="Mark course as mandatory">
        <p>
          You can now mark a course as mandatory. You can mark the course as
          mandatory for all participants from the course Settings{' -> '}
          Mandatory and target schedule page. Alternatively, you can mark the
          course as mandatory for only selected users or groups from the course
          Share page.
        </p>
        <p>
          Participants can see if a course is marked as mandatory. Courses
          marked as mandatory can also be filtered from the Courses page.
        </p>
        <p>
          Supervisors can also filter mandatory courses in the My team{' -> '}
          Analytics{' -> '}Courses page and see for which users the course has
          been marked as mandatory.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Persistent course target schedule for groups">
        <p>
          You can now add a persistent target schedule for a group, if a course
          has been shared with that group. This means that if a new user is
          added to the group, they will automatically get the target schedule of
          that group.
        </p>
        <p>
          You can add the group-specific target schedule from the course Share
          page or the group Courses page.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-10-02">
      <UpdatesListItem title="Completion matrix">
        <p>
          You can now see progress status data from users in a completion
          matrix. You can separately choose which courses, learning paths,
          achievements or calendar events you want to see data from.
        </p>
        <p>
          The completion matrix is available for all admins from the Analytics
          {' -> '}Completion matrix page and for supervisors from the My team
          {' -> '}Completion matrix page.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-09-10">
      <UpdatesListItem title="Categories for learning paths">
        You can now add categories for learning paths. You can do this in the
        learning path Settings page. You can then see categories in the Learning
        paths page and filter by category.
      </UpdatesListItem>

      <UpdatesListItem title="Categories for achievements">
        You can now also add categories for achievements. You can do this in the
        achievement Settings page. You can then see categories in the
        Achievements page and filter by category.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-06-01">
      <UpdatesListItem title="Pending requests in my team page">
        Supervisors now have a separate page for viewing all pending requests
        for their team members. Supervisors can find the page from My team
        {' -> '}Analytics{' -> '}Pending requests.
      </UpdatesListItem>

      <UpdatesListItem title="Hide expiring completions in my team page">
        Supervisors can now hide expiring or expired completions in the my team
        page, if the completions are not relevant.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-05-04">
      <UpdatesListItem title="AI translations for course language versions">
        <p>Course language versions can now be translated using AI.</p>
        <p>
          You can translate a full language version from the course Settings
          {' -> '}Language settings page.
        </p>
        <p>You can also translate individual content from the course editor.</p>
      </UpdatesListItem>

      <UpdatesListItem title="Group conversations">
        <p>Achievements now support a group conversation type.</p>
        <p>
          A group conversation works similarly to the conversation notes type,
          but you can add multiple participants, and each participant can answer
          the questions.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-03-28">
      <UpdatesListItem title="Copy a competency">
        <p>
          You can now copy a competency. This will copy the levels, categories
          and user permissions of an existing competency.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="New multiple choice task settings">
        <p>
          You can now set how many options a user must choose or how many
          options they can choose in a multiple choice task. You can also choose
          to not reduce points if they select incorrect options.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Select what content to include in course pdf export">
        <p>
          You can now select what content types you want to include when
          exporting course contents as a pdf file.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-03-09">
      <UpdatesListItem title="Create a course language version from a course">
        <p>
          You can now create a course language version from an existing course.
          The course contents must match, so the other course must have the same
          number of chapters and the same types of content blocks in every
          chapter.
        </p>
        <p>
          You can find this option in the course Settings {'->'} Language
          settings page by clicking the arrow and selecting "Import from
          course".
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-12-16">
      <UpdatesListItem title="Course language versions">
        <p>
          You can now create language versions for courses. Language versions
          can be managed from the Settings{' -> '}Language settings page under a
          course.
        </p>
        <p>
          Language translations for course content can be added from the editor
          or by importing a JSON file with the translations.
        </p>
        <p>
          When a user opens a course with language versions, they first need to
          choose which language they want to complete the course in.
        </p>
        <p>
          You can find more information about language versions from our guide
          here (at the end of the chapter under the Lanugage settings heading):{' '}
          <a
            href="https://academy.vuolearning.fi/courses/guide/course-settings#dfe0beddb7c4c684"
            target="_blank"
          >
            Vuolearning - guide for online course creation
          </a>
          .
        </p>
        <p>
          <em>Further development:</em> We are planning to add a tool for
          creating a language version from another existing course a little bit
          later. We also plan to add support for AI translations.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Polish user interface translation">
        The user interface now supports Polish as a language option.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-11-26">
      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Custom email messages templates"
      >
        <p>
          You can now create custom email message templates for different
          message types in the application. You can manage email templates from
          the Superadmin {'->'} Settings {'->'} Email page.
        </p>
        <p>
          All superadmins can manage email templates. If you want an admin to
          also manage email templates, you can give them the &quot;Manage email
          templates&quot; permission.
        </p>
      </UpdatesListItem>
      <UpdatesListItem
        onlyForAdmin={true}
        title="Custom email messages templates"
      >
        <p>
          Custom email message templates can now be created for different
          message types in the application.
        </p>
        <p>
          As an admin you can only manage email templates if you are given
          permission to do so.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-10-21">
      <UpdatesListItem title="Close conversation notes">
        <p>
          You can now allow conversation notes to be closed. Answers in a closed
          conversation can not be edited anymore. If the conversation has been
          set as confidential, you can also require all participants to approve
          the closing of the conversation.
        </p>
        <p>
          You can find the settings to allow closing the conversation from the
          Access and visibility page in a converation notes achievement.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-09-25">
      <UpdatesListItem onlyForSuperadmin={true} title="AI tools in editor">
        <p>
          You can now use AI assisted content creation tools in the course
          editor. You can use AI to generate content by passing a prompt to the
          AI and optionally passing existing course content as context.
        </p>

        <p>
          The AI tools have a monthly usage limit for the environment and it
          will be reset at the start of every month.
        </p>

        <p>
          If you can't see the AI tools in the editor, it may be that they have
          been disabled in your environment.
        </p>

        <p>
          As a superadmin you can manage settings related to using AI from the
          Superadmin{' -> '}Settings{' -> '}AI features page. Here you can also
          find monthly AI usage statistics.
        </p>

        <p>
          As default using AI tools have been allowed for all admin users, but
          you can change this from the settings. If you do not allow AI tools
          for all admins, you can allow selected admin users to use the AI tools
          by granting a permission from the Superadmin{' -> '}Admins page.
        </p>
      </UpdatesListItem>

      <UpdatesListItem onlyForAdmin={true} title="AI tools in editor">
        <p>
          You can now use AI assisted content creation tools in the course
          editor. You can use AI to generate content by passing a prompt to the
          AI and optionally passing existing course content as context.
        </p>

        <p>
          The AI tools have a monthly usage limit for the environment and it
          will be reset at the start of every month.
        </p>

        <p>
          If you can't see the AI tools in the editor, it may be that they have
          been disabled in your environment.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-06-23">
      <UpdatesListItem title="Confidential conversation notes">
        <p>
          Conversation notes achievements now support setting the conversation
          as confidential. The achievement owner can allow this from the Access
          and visibility settings in the achievement.
        </p>

        <p>
          If a conversation is set as confidential, only the users who have been
          given access to the conversation will be able to see the user's
          answers. Note that setting a conversation as confidential is permanent
          and can not be undone.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Send email when a user joins a calendar event">
        You can now choose to send an email to any email addresses when a user
        joins a calendar event. This can be useful ex. if you are the event
        organizer and want a notification every time someone joins the event.
        This setting can be found from the calendar event Participant settings
        page.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-05-18">
      <UpdatesListItem title="Alternative home page banner layout">
        The home page banner can now be displayed with an alternative layout
        that scales the image based on the viewport width and keeps the image
        proportions fixed.
      </UpdatesListItem>

      <UpdatesListItem title="Updated user interface">
        The user interface has been updated with a wider viewport, updated
        navigation styles and other style updates.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-04-23">
      <UpdatesListItem title="Save filters in Users page">
        <p>
          You can now save filters in the Users page, if you ex. use some filter
          options regularly. You can try this by selecting some filters and then
          clicking the Save button next to selected filters.
        </p>

        <p>
          The option to save filters is initially only available in the Users
          page, but we plan to bring this to other pages with filters later.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-02-20">
      <UpdatesListItem title="Email confirmation when signing up to a calendar event">
        You can now enable sending an email confirmation when a user signs up to
        a calendar event. The message contains the event details and possible
        user specific sign up information. You can find the setting from the
        Participant settings page in the calendar event.
      </UpdatesListItem>

      <UpdatesListItem title="Single choice task">
        You can now add a single choice task to courses. It behaves like a
        multiple chioice task, but the user can always only select one answer
        option.
      </UpdatesListItem>

      <UpdatesListItem title="Support for multiple attachments in achievements">
        You can now add multiple attachments to achievement completions.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-01-28">
      <UpdatesListItem title="Course version history">
        <p>
          You can now see a history of different versions of a courses content.
          A new version is automatically created when changes are saved to the
          course contents. You can also:
        </p>
        <ul>
          <li>
            <strong>Tag versions:</strong> you can tag a specific version of a
            course to make it more easy to track changes.
          </li>
          <li>
            <strong>Revert to an older version:</strong> you can revert to an
            older version of the course. This will only affect the contents in
            the chapters, so no settings will change. You can also do this for a
            single chapter only.
          </li>
          <li>
            <strong>See what version a user completed:</strong> in the tasks and
            analytics page, you can see what version of the course a user
            completed. You can preview what the course contents looked like and
            what answers the user submitted.
          </li>
        </ul>
        <p>
          You can browse the version history, add tags or revert to an older
          version from the course Edit page.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-12-10">
      <UpdatesListItem title="Notifications for admins in the home page">
        <p>
          Admin users can now see notifications in the home page about some data
          they might need to react to. For now the notifications include:
        </p>
        <ul>
          <li>Unreviewed answers from administered courses</li>
          <li>Unread feedbacks from administered courses</li>
          <li>Unread chat messages from administered courses</li>
          <li>
            Pending requests from administered courses, achievements or calendar
            events
          </li>
        </ul>
      </UpdatesListItem>

      <UpdatesListItem title="Improved calendar event queue management">
        If you limit the number of participants for a calendar event, you can
        now choose if you want to use the queue and how many users are allowed
        to join the queue. The users will also see their queue position and see
        more clear info if an event is full.
      </UpdatesListItem>

      <UpdatesListItem title="Improved H5P support">
        We have improved support for H5P elements with multiple pages or
        multiple questions. If you have multiple tasks inside a single H5P
        element, you can now specify this in the the editor so that the score
        would be correctly calculated.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-11-14">
      <UpdatesListItem title="Filter valid completions">
        You can now filter valid completions, if a course completion or
        achievement completion may expire. You can find the filter option from
        ex. the Users page, the course Tasks and analytics page or the
        achievement Users page.
      </UpdatesListItem>

      <UpdatesListItem title="Edit course completion form">
        If you enable course completion, you can now edit the contents in the
        completion form that is displayed at the end of the course for the user
        to check their results. You can change the heading, content or button
        text of the form.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-10-31">
      <UpdatesListItem title="Comment and request changes to open question answers">
        <p>
          You can now add comments to open question answers that are not
          intended to be reviewed. You can also request changes to a reviewable
          answer before giving the actual review. When adding a comment or
          review, you can also choose to send an email notification to the user.
        </p>
        <p>
          You can find this functionality from the course Tasks and analytics
          page when viewing open question answers.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-10-17">
      <UpdatesListItem title="Updates to course and learning path analytics filters and data">
        The filtering options in the course Task and analytics page have been
        updated and we also added some more data in the analytics view. The
        filtering options in the learning path Follow page have also been
        updated and you can also find a new view for displaying progress for
        each step in the path.
      </UpdatesListItem>

      <UpdatesListItem title="Updates to how we ask for consent">
        When a new user creates an account in the learning platform, they are
        now asked if they are in an employment or contractual relationship with
        the training provider. If they are, we do not anymore separately ask for
        consent to process their data. The reason for this change is to make it
        more clear what are the basis for processing a user's data.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-07-11">
      <UpdatesListItem title="Improved sharing of achievements from learning paths">
        If an achievement is added to a learning path step, the learning path
        participants will now automatically have access to the achievement. The
        participants will not receive a completion automatically, this will
        still be either the responsibility of the achievement administrator, or
        the user themselves if allowed.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-07-09">
      <UpdatesListItem title="Redesigned users page filters">
        We redesigned the filters in the Users page so they would be more easy
        to use. You can also select multiple values which should make the
        filters more flexible. If you open a user profile and go back to the
        users page, the active filters are also preserved.
      </UpdatesListItem>

      <UpdatesListItem title="Competency matrix">
        You can now find a new Competency matrix page under the Users page which
        displays competency and competency profile data for users. The data can
        also be exported to an excel file.
      </UpdatesListItem>

      <UpdatesListItem title="New filters for completion history">
        In the Analytics{' -> '}Completion history page you now have more
        options to filter completions.
      </UpdatesListItem>

      <UpdatesListItem title="Calendar events with same title">
        You can now create multiple calendar events with the same title.
        Previously this was not possible as the title was required to be unique.
        To more easily identify calendar events, we now display the start and
        end date in different views in the application.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-05-21">
      <UpdatesListItem title="User summary email">
        Every user can now subscribe to a summary email from their profile
        settings page. The email includes the latest activity related to the
        user from the last day, week or month. Users can choose what activity
        they want notifications about, such as new access rights, upcoming
        target schedules or expiring completions.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-05-02">
      <UpdatesListItem title="Publishing learning paths">
        <p>
          Learning paths now have a start date and optional end date that work
          similarly as for courses. This means that a new learning path is not
          available to users until you publish it. You can also optionally close
          a learning path, which means that the step contents will not be
          available to the users anymore.
        </p>

        <p>
          All existing learning paths have been automatically published and are
          available if they have been shared with users.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="French user interface translation">
        The user interface now supports French as a language option.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-04-14">
      <UpdatesListItem title="Mandatory tasks">
        You can now set a task as mandatory. This means that a user must submit
        an answer before they can complete the course. You can find the setting
        in task blocks in the editor under "Show more options".
      </UpdatesListItem>

      <UpdatesListItem title="Changed behavior when hiding content before user has answered">
        Previously you could hide content after a task in a single chapter until
        the user had answered. This setting has now been changed so that it will
        hide content in all chapters after the task until the user has answered.
        This setting is available in task blocks in the editor under "Show more
        options".
      </UpdatesListItem>

      <UpdatesListItem title="Choose number of option in likert">
        You can now choose the number of options in a likert block. We also
        added a a colormap setting for likert options allow you to visualize
        different kind of likert questions. You can find these settings in a
        likert block in the editor.
      </UpdatesListItem>

      <UpdatesListItem title="Link field for calendar event">
        You can now find a separate link field in calendar event settings in
        addition to the location field. You can also optionally set the link
        text.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-03-12">
      <UpdatesListItem title="Completion history page">
        You can now find a new completion history page under the Analytics page.
        This will show all course completions, learning path completions,
        achievements and calendar event participations in the platform. Admin
        users can see completions from courses, learning paths, achievements or
        calendar events they administer. Supervisors can additionally see all
        completions from users in their team.
      </UpdatesListItem>

      <UpdatesListItem title="Editing open question answers">
        You can now allow users to edit their open question answers. If editing
        is allowed, the user can edit their answer until the course is completed
        or until the answer has been reviewed. You can find this setting in the
        editor for each open question task.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-02-14">
      <UpdatesListItem title="Course SCORM export">
        You can now export a course as a SCORM package. This makes it possible
        to use a course outside the platform if needed. You can fund the
        functionality from the Export SCORM page found under the course Admin
        page.
      </UpdatesListItem>

      <UpdatesListItem title="Text formatting options">
        <p>
          In several settings, you can now format text as bold, italic or
          underlined or add links to the text. This is now possible in the
          following:
        </p>
        <ul>
          <li>Course description</li>
          <li>Learning path description</li>
          <li>Achievement description</li>
          <li>Task list tasks</li>
          <li>Conversation notes questions</li>
          <li>Calendar event description</li>
          <li>Home page info text</li>
          <li>Group specific info text</li>
        </ul>
      </UpdatesListItem>

      <UpdatesListItem title="Copy a learning path">
        You can now create a copy of an existing learning path. All steps and
        settings will be copied, but participants will not be copied. You can
        find the functionality from the Admin page in the learning path.
      </UpdatesListItem>

      <UpdatesListItem title="Add links inside a course">
        You can now more easily create links inside a course. In the editor
        every content block has a button in the bottom right corner for copying
        a link to the block. You can then paste the link to a Text block for
        example. In the reader view internal links open in the same tab or
        window for smoother navigation.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-02-01">
      <UpdatesListItem title="Support for multiple completions in achievements">
        <p>
          You can now add multiple completions for a user inside an achievement.
          If a new completion is added, the current one will be archived, but it
          will still be accessible.
        </p>
        <p>
          You can add a new completion by adding an existing user from the Add
          users or Add completions button in the Users page in an achievement.
          You can also click on the three dots next to a user in the users list
          and select Add new completion.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Custom fields for calendar event participants">
        You can now add custom fields for calendar event participants that a
        user can fill in when they sign up for a calendar event. You could for
        example ask about food allergies from users who attend an event. A
        calendar event owner can also add or edit fields for participants.
        Custom fields can be added from the Participant settings page in the
        calendar event.
      </UpdatesListItem>
      <UpdatesListItem title="Excel export for calendar event participants">
        You can now export calendar event participants data to an excel file.
        You can do this from the Participants page in the calendar event.
      </UpdatesListItem>
      <UpdatesListItem title="Link achievements to calendar events">
        You can now link achievements to calendar events. When a user
        participates in a calendar event, they will automatically be added to
        all linked achievements. You can link achievements from the Participant
        settings page in the calendar event.
      </UpdatesListItem>
      <UpdatesListItem title="German user interface translation">
        The user interface now supports German as a language option.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-12-13">
      <UpdatesListItem title="New My team page">
        The My team page for supervisors has been updated. Supervisors can now
        see more detailed analytics about courses, learning paths, achievements
        and calendar events their team members have participated in.
      </UpdatesListItem>
      <UpdatesListItem title="New Users page filters">
        You can now filter users by "Account not locked" and "Account not
        expired" in the Users page.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-10-19">
      <UpdatesListItem title="New user Excel reports">
        <p>
          You can now find new Excel reports from the Users page. You can choose
          what data you want to export and how to sort the rows and what columns
          you want to include. There are 6 different report types:
        </p>
        <ul>
          <li>Users</li>
          <li>Completion history</li>
          <li>Courses</li>
          <li>Learning paths</li>
          <li>Achievements</li>
          <li>Calendar events</li>
        </ul>
        <p>
          You can download the the new Excel reports by clicking the three dots
          at the top right of the page and selecting "Export to Excel".
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-10-11">
      <UpdatesListItem title="Choose grading type in open question">
        If an open question has been set to be graded, you can now choose how it
        should be graded. The options are text only, text and star rating or
        text and points.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-10-03">
      <UpdatesListItem title="Allow user to add achievements">
        You can now allow users to add an achievement to themselves. This can be
        done by an achievement owner from the Access and visibility settings.
        You can also decide if an achievement added by the user themselves need
        to be approved by an administrator, or if the user can just outright add
        the achievement.
      </UpdatesListItem>

      <UpdatesListItem title="Allow users to edit task lists and conversation notes">
        <p>
          You can now allow a user to mark tasks as completed in a task list
          achievement. You can also allow a user to answer questions in a
          conversation notes achievement.
        </p>
        <p>
          As part of these changes we also redesigned the achievement pages so
          that the tasks or questions will now be the default view that an
          achievement owner sees. In this view you can also edit a task or
          question and allow users to edit the task or question.
        </p>
      </UpdatesListItem>

      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Assign all supervisors to an achievement"
      >
        You can now automatically assign all supervisors to an achievement from
        the achievements Supervisors page. This means that all supervisors can
        manage the achievement for their own team members. You can still also
        assign supervisors one by one.
      </UpdatesListItem>

      <UpdatesListItem title="Updates to calendar events">
        <ul>
          <li>You can now set the last date when users can join an event</li>
          <li>
            You can now copy a calendar event to create a new event, this can be
            done from the Admin page
          </li>
          <li>
            You can now more easily manage participants by selecting users and
            applying an action on the selected users
          </li>
        </ul>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-08-31">
      <UpdatesListItem
        onlyForAdmin={true}
        title="Levels and descriptions for user competencies"
      >
        You can now add levels and descriptions to user competencies. You can
        also add categories to competencies. Creating, updating and deleting
        user competencies can be done centrally from the User competencies page
        found under the Users page.
      </UpdatesListItem>

      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Levels and descriptions for user competencies"
      >
        <p>
          You can now add levels and descriptions to user competencies. You can
          also add categories to competencies. Creating, updating and deleting
          user competencies can be done centrally from the User competencies
          page found under the Users page.
        </p>
        <p>
          Creating, updating and deleting competencies can by default be done by
          all admin users, but this can optionally be limited to only superadmin
          users from the Settings page found under the User competencies page.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Competencies marked by users">
        It is now possible for regular users to add competencies for themselves.
        You can allow this separately for each competence in the competence
        settings. After this the user can add the competence from their own
        profile page.
      </UpdatesListItem>

      <UpdatesListItem onlyForSuperadmin={true} title="Competence profiles">
        <p>
          Superadmin users can now create competence profiles to which they can
          add one or more competencies. Managing competence profiles can be done
          from the Competence profiles page found under the User competencies
          page. Here you can also see a list of users that match a competency
          profile.
        </p>
        <p>
          The competencies of a single user can also be compared to all
          competence profiles from the user profile page.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-08-17">
      <UpdatesListItem title="New completion history page in user profile">
        A new Completion history page has been added to the profile. This
        contains all courses, learning paths, achievements and calendar events
        the user has completed. You can also download the completion history as
        an excel file.
      </UpdatesListItem>

      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Add supervisors to achievements"
      >
        <p>
          A new Supervisors page to achievements where superadmins can add
          supervisors to an achievement. This allows a supervisor to mark
          achievements as completed for their team members. In task lists
          supervisors can also mark tasks as completed and in conversation notes
          supervisors can add answers to questions.
        </p>
        <p>
          A supervisor can see their assigned achievements in the Achievements
          page or in the My team page.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-05-05">
      <UpdatesListItem title="New search page">
        You can now search for courses, learning paths, groups, achievements and
        calendar events from a new search page. Searching for courses also
        searches content inside the courses. You can access the search page from
        the search input in the home page or from the icon at the top of the
        page.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-04-20">
      <UpdatesListItem title="My learning paths in home page">
        Users who are participants in a learning path will now see their most
        recently accessed learning paths in the home page.
      </UpdatesListItem>
      <UpdatesListItem title="Available courses and learning paths in the home page">
        We now include available courses and available learning paths in the
        home page by default. These should become visible if the home page has
        not been customized already. If the home page was already customized it
        will not change.
      </UpdatesListItem>
      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Link a group to a supervisor"
      >
        Superadmins can now link a group to a supervisor. This means that all
        users in the group will become supervised users of the supervisor. You
        can still add users to a supervisor directly or with attribute
        conditions, but this way you don't have to manage the users in two
        places if you already have existing groups that could be used.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-04-13">
      <UpdatesListItem onlyForAdmin={true} title="New home page">
        <p>
          We added a new home page that shows a summary of relevant content to
          the user. Users can now be notified of expiring completions,
          approaching target shcedules and upcoming events on the home page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem onlyForSuperadmin={true} title="New home page">
        <p>
          We added a new home page that shows a summary of relevant content to
          the user. Users can now be notified of expiring completions,
          approaching target shcedules and upcoming events on the home page.
        </p>
        <p>
          As a superadmin, you can also customize what the home page will look
          like:
        </p>
        <ul>
          <li>You can add a banner image to the top of the home page</li>
          <li>You can display an info text for all users</li>
          <li>You can choose what type of notices the user will see</li>
          <li>
            You can add customized sections of courses or learning paths to the
            home page
          </li>
        </ul>
        <p>
          You can find the settings to edit the home page from the Superadmin
          {` -> `}
          Settings page. You can also find a more detailed description of the
          home page changes here:{' '}
          <Link
            external={true}
            href="https://www.vuolearning.com/en/campaigns/learning-platform-updates"
            openInNewTab={true}
            text="https://www.vuolearning.com/en/campaigns/learning-platform-updates"
          />
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Redesigned courses, learning paths and achievements pages">
        <p>
          The courses, learning paths and achievements pages have been
          redesigned with improved filtering options. They are also now visible
          to non-admin users where they can see content they have participated
          in or completed.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Pictures for learning paths">
        <p>You can now add a picture to a learning path.</p>
      </UpdatesListItem>
      <UpdatesListItem title="Achievements and calendar events in learning paths">
        <p>
          Achievements and calendar events can now be part of a learning path.
          For these, an admin needs to mark the achievement or calendar event as
          completed. As part of this change we have updated the terminology so
          that a learning path now consists of steps.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Alternative items in learning paths">
        <p>
          You can now add alternative items to a learning path. One step in a
          learning path can consist of ex. multiple courses, which means that
          the user has to complete one of those courses to complete the step.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="More flexible reminder emails">
        <p>
          If you have setup email reminders for expiring completions or
          approaching target schedules, you can now choose how many reminders
          will be sent and when they will be sent.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-12-12">
      <UpdatesListItem title="Delete course analytics for users">
        <p>
          You can now delete all course analytics related to a user, including
          reading progress, video progress and task answers. This can be done
          from a users context menu in the Tasks and analytics page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Discussion comments order">
        <p>
          Discussion comments can now be ordered by newest or oldest comment
          first.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="More detailed H5P answer data">
        <p>
          We have made updates to how answer data is gathered and displayed for
          H5P tasks. New data is available for H5P tasks that have been created
          after the update.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-11-29">
      <UpdatesListItem title="More versatile attribute conditions">
        <p>
          Attribute conditions (ex. in groups) now support more versatile
          conditions. You can for example define, that a user attribute should
          not equal some value for users to be included.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Moving blocks in editor redesigned">
        <p>
          Moving blocks in the editor has been redesigned. Instead of dragging,
          you can now simply click the move button, optionally select multiple
          blocks, and then place them to a new position.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Filter users by logged in status">
        <p>
          You can now filter users in the Users page by whether the user has
          sometimes logged in to the platform or if they have never logged in to
          the platform.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-10-27">
      <UpdatesListItem title="My team page for supervisors">
        <p>
          Supervisors now have access to a new My team page where they can see
          data related to their supervised users. Supervisors can also subscribe
          to a summary email about their supervised users recent activity.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-09-30">
      <UpdatesListItem title="New event calendar">
        <p>
          You can now create events in the new event calendar. The event
          calendar provides an easy way to share information about upcoming
          trainings, webinars or other events. The calendar is shared by all
          users on the platform and signing up to events can also be done
          through the calendar. You can find the link to the calendar from the
          top navigation.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="CSV user import">
        <p>
          Superadmins can now create user accounts in the platform by importing
          a CSV file with user information. This option is available in the
          Users page, and you can see an example format of what the file
          contents should look like.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="New filter options in users page">
        <p>
          We added an option to the Users page to filter users by account type.
          You can filter accounts with or without an email address, expired or
          locked accounts and admin and superadmin accounts.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Tasks points in chapter">
        <p>
          Users can now see task points for each task they have answered
          directly in the chapter.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-08-25">
      <UpdatesListItem title="User competences and ambitions">
        <p>
          Users can now have competences and ambitions attached to their
          profile. Competences can be given manually by admins or automatically
          by ex. completing a course. Ambitions can be added by each user in
          their own profile.
        </p>
        <p>
          Admins can find users based on comptetencies or ambitions from the
          Users page. They can also see analytics data about competencies and
          ambitions on the platform from the Analytics page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Updated user profile">
        <p>
          We have made some updates to the user profile page and added a
          timeline which includes a summary of the users important events. Users
          can also now upload an image as their profile picture.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Supervisors">
        <p>
          Superadmins can now set admins as supervisors for other users.
          Supervisors will be able to view analytics dat from all courses,
          learning paths and achievements for their supervised users.
          Supervisors can see the data from the Users page and the user profile
          page.
        </p>
        <p>
          We have also deprecated the system wide analytics viewing rights
          functionality that was previously a part of groups. All existing users
          who had the system wide analytics viewing rights have been
          automatically added as supervisors for the group users.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="More detailed admin permissions">
        <p>
          Superadmins can now give more detailed permissions to admins. An admin
          user can be given permissions to create courses, create groups, create
          learning paths, create achievements, manage users or manage user
          custom attribute settings.
        </p>
        <p>
          All existing admins have been automatically given permissions to
          manage users and create courses, groups, learning paths and
          achievements.
        </p>
        <p>
          As part of this change we have also changed the "Edit users"
          permission to "Manage users". Previously all admins were allowed to
          delete user accounts, and only admins with the "Edit users" permission
          were allowed to edit user attributes. The "Manage users" permission
          allows the admin to both edit user attributes and delete a user
          account. Because of this change some admin users who previously could
          not edit user attributes will now be able to edit them, but if there
          is a need a superadmin can remove this permission from an admin.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-06-20">
      <UpdatesListItem title="Achievement types">
        <p>
          You can now create achievements of different types. We also renamed
          the "External achievements" page to "Achievements". There are now four
          types of achievements:
        </p>
        <ul>
          <li>
            <em>Achievement</em> is the same as external achievements previously
          </li>
          <li>
            <em>Conversation notes</em> can be used for example to keep track of
            development discussions
          </li>
          <li>
            <em>Milestone</em> can be used to mark down simple milestones
          </li>
          <li>
            <em>Task list</em> can be used for example as part of onboarding
          </li>
        </ul>
      </UpdatesListItem>
      <UpdatesListItem title="Users page filters">
        <p>
          We moved course and group filters in the Users page under a single
          Filters option. We also added the option to filter users by learning
          paths and achievements.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Admin groups">
        <p>
          Superadmins can now add other admins and superadmins to admin groups.
          An admin group can be added for example as a course owner or course
          admin similarly to how indivudual admin users can be added. An "All
          admins" group that includes all admins and superadmins has been
          created by default.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-05-13">
      <UpdatesListItem title="Course target schedule">
        <p>
          You can now set a target schedule for a single course similarly to
          learning path courses previously. You can use the target schedule to
          send notifications to users and optionally prevent access to the
          course after the target schedule has expired. You can set the course
          target schedule under the course Settings page and you can edit an
          individual users target schedule from the Share page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Requesting access to a course">
        <p>
          There is now a new course access option in the Share page which allows
          all users on the platform to request access to the course. These
          courses are visible on the home page in the "Available courses"
          section. A course admin can accept or deny access requests from the
          Share page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Notifications">
        <p>
          Users will now see notifications of various events from the header
          notification icon. Notifications are displayed, for example, about
          answer reviews, discussion answers, target schedules or new chapters
          in a course.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Changing the default task points for open questions">
        <p>
          The default task points for open questions have been changed to 0, as
          open questions do not have reviews available by default. If you enable
          reviews you can also set the task points for the task.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-03-28">
      <UpdatesListItem title="Update multiple users">
        <p>
          You can now update multiple users simultaneously in the Users page.
          Supported actions for now include deleting multiple users, locking
          multiple users or editing attributes for multiple users. You can find
          the actions from the top right corner of the users list.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Send a message to course, group or learning path users">
        <p>
          You can now send a message to course users directly from the course
          Tasks and analytics page. You can also send a message to group or
          learning path users directly from the Share page in a group or
          learning path.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Course summary email">
        <p>
          You can now subscribe to a course specific summary email which
          includes the latest events from the course from the last day, week or
          month. The email will give you information about new task answers,
          feedbacks, discussion comments, chat messages or course completions.
          You can subscribe to the email from the course settings page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Send path certificate automatically">
        <p>
          You can now choose to send the learning path certificate automatically
          to the user or an administrator from the learning path settings.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Email reminders about expiring external achievements">
        <p>
          You can now receive email reminders if an external achievement is
          expiring for a user.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-03-11">
      <UpdatesListItem title="Emojis and reactions in discussion comments">
        <p>
          You can now add emojis to discussion comments. Users can also add
          reactions to comments.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Learning path description">
        <p>
          You can now add a description to a learning path. Users can see the
          description below the learning path title.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-02-28">
      <UpdatesListItem title="Updated home page with courses">
        <p>
          We updated the home page so that administered courses are always
          displayed as a list and student courses are always displayed as cards
          in a grid.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Displaying changed progress data">
        <p>
          Course progress data now includes an indicator if the data has changed
          after the user completed the course. This may happen, if for example a
          user returns to read the material sometime later.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Displaying next course in learning path">
        <p>
          If a course is part of a learning path, there is now a link to the
          next course at the end of the last chapter.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Improvements to the video player">
        <p>
          The video player now remembers the timestamp where the user last
          watched the video if the user does not watch the full video at once.
          New buttons for jumping 10 seconds backward or forward have also been
          added.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-01-17">
      <UpdatesListItem title="Heading levels">
        <p>
          We now support more heading levels. You can choose if a heading in a
          chapter is level H2 or H3.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Select all content under a heading">
        <p>
          You can now select all content blocks under a heading. Do this by
          first selecting the heading from the right side of the block and then
          selecting "Select all blocks under this heading" from the menu.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Keyboard shortcuts for text formatting">
        <p>
          You can now set text as bold (ctrl/cmd + b), italic (ctrl/cmd + i),
          underlined (ctr/cmd + u) or code (ctrl/cmd + shift + c) using keyboard
          shortcuts.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Requirements for correct multiple choice options">
        <p>
          If a multiple choice task has more than one option marked as correct,
          you can now choose how many options the user must select for the
          answer to be marked as correct.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Deleting your own answer in the reader for admins">
        <p>
          A course admin can now remove their own answer directly from the
          reader view, which should make testing tasks easier.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Highlighting unreviewed tasks">
        <p>
          Unreviewed tasks are now highlighted in the Tasks and analytics pages.
          On the task page you can also filter only unreviewed answers.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Manually mark course as complete for multiple users">
        <p>
          You can now manually mark a course as complete for multiple users. You
          can do this from the Tasks and analytics page by selecting "Mark
          multiple as complete" from the menu in the upper right corner.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="New Discussion page">
        <p>
          There is a new Discussions page under Tasks and analytics that
          contains a summary of all discussions in the course. You can also add
          comments to discussions directly through this page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Email reminders to admins about expiring completions and expiring target schedules">
        <p>
          You can now choose to send email reminders to admins about expring
          course completions in the course requirements settings. You can also
          choose to send email reminders to admins about expiring course target
          schedules from the path settings page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="User interface translations for Norwegian and Estonian">
        <p>We translated the user interface to Norwegian and Estonian.</p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-12-21">
      <UpdatesListItem title="External achievements">
        <p>
          You can now create external achievements on the platform and add users
          to them. External achievements can be used to keep track of trainings
          that have been completed outside the platform. A users external
          achievements can be seen in the users profile on the Completions page.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-11-05">
      <UpdatesListItem title="Change element type">
        <p>
          You can now change the element type in the editor for text, heading,
          list or quote blocks. This way you don't have to create a new block
          and paste the content, if you would like to ex. turn a text block to a
          heading block. You can find this option in the bottom left corner of
          the element in the editor.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Group admins with limited permissions">
        <p>
          You can now add a group admin with limited permissions. Permissions
          include managing users, managing courses or viewing group analytics.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-10-13">
      <UpdatesListItem title="Text highlight">
        <p>
          You can now highlight text in a text block by selecting a background
          color or border color for the block in the editor.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="H5P block">
        <p>
          You can now upload an H5P package directly to a chapter. The H5P
          element can optinally be set as a task, which means the user can get
          points for completing it ant it can affect course completion. You can
          find the H5P block in the editor under the Embed option.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-10-04">
      <UpdatesListItem title="Likert block">
        <p>
          We added a new content type in the editor for likert questionnaires.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Fill in task">
        <p>
          We added a new task type in the editor where you can ask users can
          fill in missing words.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Sequencing task">
        <p>
          We added a new task type in the editor where you can ask users to
          order items in the correct order.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Define task points">
        <p>
          For each task block in the editor, you can now define how many task
          points it is worth.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-08-31">
      <UpdatesListItem title="Manually mark course as completed">
        <p>
          You can now manually mark a course as completed or uncompleted for a
          single user.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-08-13">
      <UpdatesListItem title="New analytics pages">
        <p>
          You can now find new user, course and learning path analytics via the
          top navigation.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Search in editor">
        <p>You can now search content from chapters in the editor.</p>
      </UpdatesListItem>
      <UpdatesListItem title="Download video files">
        <p>
          You can now download video files that you have uploaded in the editor.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Unified user management">
        <p>
          All user management for superadmins have been moved to the Users page.
          Managing user admin rights is still done from the superadmin page,
          however.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-06-04">
      <UpdatesListItem title="SCORM analytics">
        <p>
          You can now track progress analytics from SCORM packages. Supported
          SCORM versions are now SCORM1.2 and SCORM2004.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="New numeric question block type">
        <p>
          We added a new numeric question block, where the user answers a
          question with a number. The use receives points if the answer was
          correct.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-05-19">
      <UpdatesListItem title="Improved group reporting">
        <p>
          Group reporting has been updated and the group owner can now track the
          progress of group users from the group page.
        </p>
        <p>
          We also added a new analytics viewing rights setting that allows
          admins to see progress from a group users all courses, even those that
          have not been added to the group. This setting can for now be edited
          by superadmins only.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-05-04">
      <UpdatesListItem title="Two-factor authentication">
        <p>
          We now support two-factor authentication with an authenticator app.
          Signing in is done with a password and a verification code from the
          app. Two-factor authentication can be activated from the profile page.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-03-11">
      <UpdatesListItem title="Learning paths">
        <p>
          Learning paths can be used to define a set of courses that the user
          must complete in order. You can find more information about learning
          paths from our{' '}
          <Link
            external={true}
            openInNewTab={true}
            href="https://academy.vuolearning.fi/courses/guide"
            text="guide"
          />
          .
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Target schedules">
        <p>
          With learning paths you can also set a target schedule when a course
          should be completed and optionally prevent access the the course after
          the deadline has passed. The target schedule can be set for all users
          on a course but also for each user separately.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="New home page">
        <p>
          Following the launch of learning paths we have also updated the home
          page. A user by default now sees their last opened courses and an
          admin sees courses that have been last edited.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-02-25">
      <UpdatesListItem title="Custom text in certificates">
        <p>
          You can now add custom text to course certificates. You can also see a
          preview of the certificate in course completion settings.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-01-18">
      <UpdatesListItem title="Discussion comment editing">
        <p>Users can now edit their own discussion comments.</p>
      </UpdatesListItem>
      <UpdatesListItem title="Anonymous discussion comments">
        <p>You can now enable anonymous comments in the discussion block.</p>
      </UpdatesListItem>
      <UpdatesListItem title="Multiple choice feedback settings">
        <p>
          You now have the option to set a feedback text for each option or set
          feedback texts based on if the answer was correct or not.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Updated analytics and tasks data fetching">
        <p>
          Analytics and tasks data are now fetched from a cache which should
          improve performance with large datasets.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2020-10-14">
      <UpdatesListItem title="Course categories">
        <p>
          You can now attach categories to courses. Courses can be filtered by
          category on the courses page.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Preliminary SCORM support">
        <p>
          You can now upload SCORM packages with the Embed block. SCORM packages
          do not yet support storing task or analytics data, but we plan to
          support these in the future.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Code block">
        <p>
          We updated the Pre block to Code block, where you can optionally now
          add syntax highlighting.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="New page for product updates" />
    </UpdatesItem>
  </div>
);

export default UpdatesContentEn;
